import { useEffect, useState } from "react";
import { Link, Outlet, useNavigate, NavLink } from "react-router-dom";
import { usePeticion, ESTADOS, Exito } from "../herramientas";

export default function Index() {
  const nombreOperacion = "Comisiones";

  const [estado, setEstado] = useState(ESTADOS.CARGANDO);
  const [estadoTabla, setEstadoTabla] = useState(ESTADOS.CARGADO);
  const [comisiones, setComisiones] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [total, setTotal] = useState(0);
  const [idUsuario, setIdUsuario] = useState();

  const navigate = useNavigate();
  const peticion = usePeticion();

  const fechaActual = new Date();
  // const fechaHoy = fechaActual.getFullYear() + "-" + (fechaActual.getMonth() + 1).toString().padStart(2, '0') + "-" + fechaActual.getDate().toString().padStart(2, '0')

  const fechaMesAnterior = new Date(fechaActual);
  fechaMesAnterior.setMonth(fechaMesAnterior.getMonth() - 1);
  // const fechaAnterior = fechaMesAnterior.getFullYear() + "-" + (fechaMesAnterior.getMonth() + 1).toString().padStart(2, '0') + "-" + fechaMesAnterior.getDate().toString().padStart(2, '0')

  const [hasta, setHasta] = useState(
    fechaActual.getFullYear() + "-" + (fechaActual.getMonth() + 1).toString().padStart(2, "0") + "-" + fechaActual.getDate().toString().padStart(2, "0")
  );
  const [desde, setDesde] = useState(
    fechaMesAnterior.getFullYear() +
      "-" +
      (fechaMesAnterior.getMonth() + 1).toString().padStart(2, "0") +
      "-" +
      fechaMesAnterior.getDate().toString().padStart(2, "0")
  );

  function getComisiones() {
    setEstadoTabla(ESTADOS.CARGANDO);
    let formData = new FormData();
    formData.append("desde", desde);
    formData.append("hasta", hasta);
    formData.append("id_usuario", idUsuario);
    setTotal(0);
    peticion("comisiones_administracion/comisiones/", { method: "POST", body: formData }, "Comisiones", "No se han podido cargar las comisiones.").then(
      (json) => {
        setComisiones(json.comisiones);
        let total = 0;
        json.comisiones.forEach((element) => {
          total = total + parseFloat(element.comision);
        });
        setTotal(total);
        setEstadoTabla(ESTADOS.CARGADO);
      }
    );
  }

  useEffect(getComisiones, [desde, hasta, idUsuario]);

  useEffect(() => {
    peticion("comisiones_administracion/usuarios/", {}, "Comisiones", "No se han podido cargar los usuarios.").then((json) => {
      setUsuarios(json.usuarios);
      setEstado(ESTADOS.CARGADO);
    });
  }, []);

  let contenido;

  let contenidoTabla;

  if (estadoTabla === ESTADOS.CARGANDO) {
    contenidoTabla = (
      <tbody>
        <tr>
          <td colSpan={2}>
            <div className="d-flex justify-content-center">
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    );
  } else if (estadoTabla === ESTADOS.CARGADO) {
    contenidoTabla = (
      <>
        <tbody>
          {comisiones.map((comision) => (
            <tr>
              <td>{(new Date(comision.fecha).toISOString().split('T')[0].split('-').reverse().join('/'))}</td>
              <td>{comision.comision}</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <th scope="col">TOTAL</th>
            <th scope="col">{total.toFixed(2)}</th>
          </tr>
        </tfoot>
      </>
    );
  }

  if (estado === ESTADOS.CARGANDO) {
    contenido = (
      <div className="d-flex justify-content-center">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  } else if (estado === ESTADOS.CARGADO) {
    contenido = (
      <>
        <form className="g-3 row mb-3" onSubmit={getComisiones}>
          <div className="col-12 col-sm-4">
            <label htmlFor="usuario" class="form-label">
              Usuario
            </label>
            <select id="usuario" className="form-select" name="usuario" value={idUsuario} onChange={(e) => setIdUsuario(e.target.value)}>
              {usuarios.map((usuario) => (
                <option key={usuario.id_usuario} value={usuario.id_usuario}>
                  {usuario.nombre}
                </option>
              ))}
            </select>
          </div>
          <div className="col-12 col-sm-4">
            <label htmlFor="desde" class="form-label">
              Desde
            </label>
            <input type="date" className="form-control" value={desde} id="desde" name="desde" onChange={(e) => setDesde(e.target.value)} />
          </div>
          <div className="col-12 col-sm-4">
            <label htmlFor="hasta" class="form-label">
              Hasta
            </label>
            <input type="date" className="form-control" value={hasta} id="hasta" name="hasta" onChange={(e) => setHasta(e.target.value)} />
          </div>
        </form>
        <table class="table table-bordered table-sm align-middle text-center">
          <thead>
            <tr>
              <th scope="col">Fecha</th>
              <th scope="col">Comisiones</th>
            </tr>
          </thead>
          {contenidoTabla}
        </table>
      </>
    );
  }

  return (
    <main className="container p-3">
      <h1>{nombreOperacion}</h1>
      {contenido}
    </main>
  );
}
